import axios from "axios";
import { apiUrl } from "../../redux/apiUrl";

const api = axios.create({
  baseURL: apiUrl,
});

export default api;
